module.exports = {"410923100":"城关镇","410923101":"韩张镇","410923102":"元村镇","410923103":"福堪镇","410923104":"张果屯镇","410923105":"千口镇","410923106":"谷金楼镇","410923200":"杨村乡","410923205":"西邵乡","410923206":"寺庄乡","410923207":"梁村乡","410923208":"近德固乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410923.json
// module id = 1732
// module chunks = 0